import ApiService from "@/api.service";
import API from "@/API";


export const GET_LIST_BUNDLE = "GET_LIST_BUNDLE";
export const SAVE_BUNDLE = "SAVE_BUNDLE";
export const DELETE_BUNDLE = "DELETE_BUNDLE";
export const SET_LIST_BUNDLE = "SET_LIST_BUNDLE";
export const GET_DETAIL_BUNDLE = "GET_DETAIL_BUNDLE";
export const UPDATE_BUNDLE = "UPDATE_BUNDLE";
export const SET_DETAIL_BUNDLE = "SET_DETAIL_BUNDLE";

export  const GET_LIST_BUNDLE_BY_SEARCH = "GET_LIST_BUNDLE_BY_SEARCH";
export  const SET_LIST_BUNDLE_BY_SEARCH = "SET_LIST_BUNDLE_BY_SEARCH";

const state = {
    bundle: [],
    bundleDetail: {},
    bundleSearch:[]
};

const getters = {
    bundle(state) {
        return state.bundle;
    },
    bundleDetail(state) {
        return state.bundleDetail;
    },
    bundleSearch(state) {
        return state.bundleSearch;
    },
};

const actions = {
    [GET_LIST_BUNDLE](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_BUNDLE}`).then(({data}) => {
                if (data) {
                    context.commit(SET_LIST_BUNDLE, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_BUNDLE](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_BUNDLE}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_BUNDLE, data);
                }
                resolve(data);
            });
        });
    },
    [GET_LIST_BUNDLE_BY_SEARCH](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`${API.GET_LIST_BUNDLE_BY_SEARCH}`, payload).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_BUNDLE_BY_SEARCH, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_BUNDLE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_BUNDLE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_BUNDLE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPDATE_BUNDLE}/${payload.id}?_method=PUT`, payload.data)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_BUNDLE](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_BUNDLE}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_BUNDLE](state, data) {
        state.bundle = data.data;
    },
    [SET_DETAIL_BUNDLE](state, data) {
        state.bundleDetail = data.data;
    },
    [SET_LIST_BUNDLE_BY_SEARCH](state, data) {
        state.bundleSearch = data.data;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};